import * as React from 'react';

export interface BooleanRenderProps {
  value?: boolean | null;
}

export const BooleanRender = (props: BooleanRenderProps) => {
  return <React.Fragment>{props.value === true ? 'Yes' : 'No'}</React.Fragment>;
};
